<template>
  <div class="p-input-select" :class="{ 'p-wrong-content': wrongNumber }">
    <p class="p-input-select__choice">
      <input
        v-if="couldInput"
        ref="p-input"
        v-model="value"
        type="text"
        :class="{ 'p-wrong-input': wrongNumber }"
        :placeholder="placeholder"
        @keyup="checkInput"
        @blur="updateValue"
      />
      <span v-else class="disable-input" @click.stop="selectModel">{{
        value
      }}</span>
      <span @click.stop="selectModel">
        <i :class="[showOptions ? 'p-arrow__top' : 'p-arrow__bottom']"></i>
      </span>
    </p>
    <ul v-if="showOptions" :style="`width:${width}`">
      <li
        v-for="(item, optionIndex) in options"
        :key="item.value"
        :class="{
          'active-li': value === item.label,
          'disable-li': item.disable
        }"
        @click.stop="select(item, optionIndex)"
      >
        {{ item.label }}
      </li>
      <li
        v-if="optionTip"
        class="p-input-select___option-tip disable-li"
        @click.stop="select({ disable: true })"
      >
        <img src="../assets/images/icon-tip.png" />
        <span>{{ optionTip }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';

export default {
  mixins: [Locale],

  props: {
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '320px'
    },
    // 默认显示
    defaultIndex: {
      type: [String, Number],
      default: '-1'
    },

    defaultValue: {
      type: [String, Number],
      default: ''
    },

    // 是否可输入
    couldInput: {
      type: Boolean,
      default: false
    },
    // 输入校验类型
    checkType: {
      type: String,
      default: 'Number'
    },
    maxWinnersDigit: {
      type: Number,
      default: 3
    },
    maxWinners: {
      type: Number,
      default: 0
    },
    // option形式提示
    optionTip: {
      type: [String, null],
      default: null
    },
  },

  data() {
    return {
      showOptions: false,
      wrongNumber: false,
      value: '',
      index: 0
    };
  },

  watch: {
    // 配合国际化切换
    options() {
      this.value = this.options[this.index].label;
    },
    defaultValue(v) {
      this.value = v;
    },
    defaultIndex(index) {
      if (index === -1) return;
      this.value = this.options[index].label;
    }
  },

  created() {
    if (this.defaultValue) {
      this.value = this.defaultValue;
      return;
    }
    if (this.defaultIndex !== '-1' && this.options[this.defaultIndex]) {
      this.value = this.options[this.defaultIndex].label;
      this.index = this.defaultIndex;
    }
  },

  mounted() {
    document.body.addEventListener('click', this.handleClickBody);
  },

  beforeDestroy() {
    document.body.removeEventListener('click', this.handleClickBody);
  },

  methods: {
    select(item, index) {
      const val = item.label;
      if (item.disable) {
        return;
      }
      this.showOptions = false;
      this.value = val;
      this.index = index;
      this.$emit('select-index', index);
      this.$emit('check-input', this.value);
    },

    inputFocus() {
      this.$nextTick(() => {
        const ele = this.$refs['p-input'];
        ele && ele.focus();
      });
    },
    setWrong() {
      this.wrongNumber = true;
    },
    checkInput(e) {
      let value = e.target.value;
      this.showOptions = false;
      this.wrongNumber = false;
      if (!value.match(/^[1-9]\d*$/)) {
        value = '';
      } else if (this.maxWinners) {
        if (Number(value) > this.maxWinners) {
          value = this.maxWinners;
          this.$iaMessage.default(
            this.t('plvIA.lottery.toast1', { t: this.maxWinners })
          );
        }
      } else if (value.length > this.maxWinnersDigit) {
        value = value.substring(0, this.maxWinnersDigit);
      }
      this.value = value.toString();
      this.$emit('check-input', this.value);
    },

    updateValue() {
      const { value } = this;
      if (!value.match(/^[1-9]\d*$/)) {
        this.value = '';
      } else if (this.maxWinners) {
        if (Number(value) > this.maxWinners) {
          this.value = this.maxWinners.toString();
        }
      } else if (value.length > this.maxWinnersDigit) {
        this.value = value.substring(0, this.maxWinnersDigit);
      }
      this.$emit('check-input', this.value);
    },

    selectModel() {
      this.wrongNumber = false;
      this.showOptions = !this.showOptions;
    },

    handleClickBody() {
      this.showOptions = false;
    },
  }
};
</script>
<style lang="scss">
.p-wrong-content {
  border: 1px solid #ff5722 !important;
  background: #ffe9e9 !important;

  .p-wrong-input {
    &::-webkit-input-placeholder {
      color: #333 !important;
    }
  }

  .p-input-select__choice input {
    background-color: #ffe9e9;
  }

  .p-input-select__choice > span .p-arrow__bottom:after {
    border-top: 5px solid #ffe9e9;
  }

  .p-input-select__choice > span .p-arrow__top:after {
    border-bottom: 5px solid #ffe9e9;
  }
}

.p-input-select {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  color: #333333;
  border: 1px solid rgba(207, 216, 220, 1);
  border-radius: 2px;
  font-size: 14px;
  box-sizing: border-box;

  &:hover {
    border: 1px solid #2196f3;
  }

  ul {
    position: absolute;
    overflow: auto;
    top: 39px;
    left: -1px;
    font-size: 14px;
    background-color: #fff;
    border: 1px solid #d8d8d8;
    border-top: none;
    z-index: 99;
    padding-left: 0;

    > li {
      width: 100%;
      height: 40px;
      padding-left: 8px;
      line-height: 40px;
      color: #333333;
      cursor: pointer;

      &:hover {
        background-color: #e3f2fd;
      }
    }

    .active-li {
      color: #2196f3;
    }

    .disable-li {
      color: #9e9e9e;
      background-color: white !important;
      cursor: not-allowed;
    }

    .p-input-select___option-tip {
      line-height: 15px;
      color: #9e9e9e;
      display: flex;
      align-items: center;
      img {
        width: 14px;
        height: 14px;
      }
      span {
        margin-left: 10px;
      }
    }
  }
}

.p-input-select__choice {
  width: 100%;
  height: 100%;
  padding-right: 40px;
  position: relative;
  margin: 0;

  input,
  .disable-input {
    height: 100%;
    width: 100%;
    padding-left: 8px;
    font-size: 14px;
    color: #333;
    border: none;
    outline: none;
    background-color: #fff;
  }

  > span {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 100%;
    cursor: pointer;
    line-height: 38px;

    .p-arrow__bottom {
      position: absolute;
      top: 16px;
      right: 24px;
    }
    .p-arrow__bottom:before,
    .p-arrow__bottom:after {
      position: absolute;
      content: '';
      border-top: 5px #fff solid;
      border-left: 5px transparent dashed;
      border-right: 5px transparent dashed;
      border-bottom: 5px transparent dashed;
    }
    .p-arrow__bottom:before {
      border-top: 5px #adadc0 solid;
    }
    .p-arrow__bottom:after {
      top: -1px;
      border-top: 5px #fff solid;
    }

    .p-arrow__top {
      position: absolute;
      top: 10px;
      right: 24px;
    }
    .p-arrow__top:before,
    .p-arrow__top:after {
      position: absolute;
      content: '';
      border-top: 5px transparent dashed;
      border-left: 5px transparent dashed;
      border-right: 5px transparent dashed;
      border-bottom: 5px #fff solid;
    }
    .p-arrow__top:before {
      border-bottom: 5px #adadc0 solid;
    }
    .p-arrow__top:after {
      top: 1px;
      border-bottom: 5px #fff solid;
    }
  }
}
</style>
